'use client';

import React from 'react';
import { useSearchParams } from 'next/navigation';
import Header from '../common/header';
import Footer from '../common/footer';
import MobileDock from '../common/mobile-dock';
import { useTranslations } from 'next-intl';

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const t = useTranslations('accessibility');
  const searchParams = useSearchParams();
  const isEmbed = searchParams.get('embed') === '1';

  if (isEmbed) {
    return (
      <div className='overflow-x-clip'>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="theme-color" content="#0A001F" />
        <main id="main-content" className='relative z-0'>
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className='overflow-x-clip'>
    <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-theme focus:text-white focus:rounded-md focus:text-sm">
      {t('skipToMainContent')}
    </a>
    <Header />
    <main id="main-content" className='relative z-0'>
      {children}
    </main>
    <Footer />
    <MobileDock />
    </div>
  )
}

export default MainLayout;